// src/components/resumo/annotations/dynamicCursors.ts
// 🎯 Cursores dinâmicos que mudam de cor

import { HighlightColor } from './annotations.types';

const colorMap: Record<HighlightColor, string> = {
    yellow: '#fbbf24',
    green: '#10b981',
    blue: '#3b82f6',
    pink: '#ec4899',
    orange: '#f97316',
    graia: '#0D3B0E',
    prussian: '#2a4a5a',
    red: '#ef4444',
    purple: '#8b5cf6',
    teal: '#14b8a6',
    cyan: '#06b6d4',
    lime: '#84cc16',
    amber: '#f59e0b',
    rose: '#f43f5e',
    violet: '#7c3aed',
    indigo: '#4338ca',
    gray: '#6b7280',
    dark: '#1f2937',
    white: '#ffffff',
    sky: '#0ea5e9',
    emerald: '#059669',
    // Pastéis — cursor usa tom escuro para visibilidade
    lemon: '#f59e0b',
    sage: '#16a34a',
    powder: '#3b82f6',
    blush: '#ec4899',
    peach: '#f97316',
    lavender: '#8b5cf6',
    aquamarine: '#14b8a6',
    salmon: '#ef4444',
    periwinkle: '#4338ca',
    honeydew: '#84cc16',
    champagne: '#d97706',
    lilac: '#a855f7',
};

export const updateHighlightCursor = (color: HighlightColor) => {
    const hex = colorMap[color];
    const encodedColor = encodeURIComponent(hex);

    const cursorSVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${encodedColor}" stroke-width="2"><rect x="4" y="4" width="16" height="16" rx="2"/></svg>`;

    // Criar/atualizar estilo dinâmico
    let styleEl = document.getElementById('dynamic-cursor-style') as HTMLStyleElement;

    if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'dynamic-cursor-style';
        document.head.appendChild(styleEl);
    }

    styleEl.textContent = `
        body.highlight-mode,
        body.highlight-mode * {
            cursor: url('${cursorSVG}') 12 12, auto !important;
        }
    `;
};

export const updateRemoveCursor = () => {
    const cursorSVG = `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="%23ef4444" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;

    let styleEl = document.getElementById('dynamic-cursor-style') as HTMLStyleElement;

    if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = 'dynamic-cursor-style';
        document.head.appendChild(styleEl);
    }

    styleEl.textContent = `
        body.remove-mode,
        body.remove-mode * {
            cursor: url('${cursorSVG}') 12 12, pointer !important;
        }
    `;
};

export const clearDynamicCursor = () => {
    const styleEl = document.getElementById('dynamic-cursor-style');
    if (styleEl) {
        styleEl.remove();
    }
};